import React from 'react';

import { Textarea } from '@this/shared/ui/inputs/textarea';
import type ShippingElement from '@this/domain/shipping_element/shipping_element2';
import { observer } from 'mobx-react';
import DatetimePicker from '../../../../../shared/datetime_picker/datetime_picker';

interface Props {
  element: ShippingElement;
  classNameForModifiedField: (...path: (string | number)[]) => string;
  shippingCategoryOptions?: { [key: string]: string };
}

const ShippingElementForm = ({ element, classNameForModifiedField, shippingCategoryOptions }: Props) => (
  <>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('category')}`}>
        種別
      </label>
      <select
        value={element.category}
        onChange={e => {
          element.category = e.target.value;
          element.categoryText = shippingCategoryOptions?.[e.target.value] || '';
        }}
      >
        {shippingCategoryOptions &&
          Object.keys(shippingCategoryOptions).map(v => (
            <option key={v} value={v}>
              {shippingCategoryOptions[v]}
            </option>
          ))}
      </select>
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper-item">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('shippedAt')}`}>
        配送日時
      </label>
      <DatetimePicker
        value={element.shippedAt}
        onChange={time => {
          element.shippedAt = time;
        }}
        disabledDays={0}
        showTime
        showPast
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper-item">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('arrivedAt')}`}>
        到着日時
      </label>
      <DatetimePicker
        value={element.arrivedAt}
        onChange={time => {
          element.arrivedAt = time;
        }}
        disabledDays={0}
        showTime
        showPast
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('number')}`}>
        特定記録番号
      </label>
      <input
        type="text"
        value={element.number}
        onChange={e => {
          element.number = e.target.value;
        }}
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('remark')}`}>
        備考
        <span className="red">（必須）</span>
      </label>
      <Textarea
        value={element.remark}
        onChange={e => {
          element.remark = e.target.value;
        }}
        rowsMin={2}
      />
    </div>
  </>
);
export default observer(ShippingElementForm);
